import SearchResult from '../search-page/search-page';


export default new class Search {
  constructor() {

    this.searchBarContainer =         '.search'

    this.searchInput =                '.search__input';
    this.searchIcon =                 '.search__icon';
    this.mobileHeaderSearchIcon =     '.js-search-open-button:not(._active)';
    this.headerSearchSvg =            '.header__search-svg'

    this.searchHistory =              '.search__history';
    this.searchHistoryItem =          '.search__history__item';
    this.searchInputCleanBtn =        '.search__input__clean';

    this.page = document.body.getAttribute('data-page-id');
    this.requestText = '';

    this.searchPageURL = 'search-page';
    this.minLengthForRequest = 2;
    this.delayForRequest = 300;
    this.timer = null;

    this.bindEvents();
  }

  bindEvents() {
    if (!$('.search').length) return;

    $(document)
      // show search block on mobile
      .on('click', this.headerSearchSvg, () => {
        const searchContainer = $(this.searchBarContainer)
        if (! searchContainer.is(':visible')) {
          searchContainer.show()
          $(this.headerSearchSvg).hide()
        }
      })
      .on('mouseenter', this.searchHistoryItem, (e) => {
        let historyItems = Array.from(document.querySelectorAll(this.searchHistoryItem))
        historyItems.forEach((item) => {
          item.classList.remove('selected')
        })
      })
      .on('click', this.searchHistoryItem, (e) => {
        this.requestText = e.currentTarget.querySelector('.search__history__item__span')?.innerHTML || ''
        $(this.searchInput).val(this.requestText)
        if (this.page !== 'search') {
          window.location.href = `/${this.searchPageURL}?search=${this.requestText}`
        } else {
          SearchResult.onRequestFilterData()
        }
        this.hideSearchHistory()
        $(this.searchInputCleanBtn).show()
      })
      .on('input', this.searchInput, (e) => {
        $(this.searchHistory).show()
        $(this.searchInputCleanBtn).show()
        this.requestText = $(e.currentTarget).val().trim();
        if (this.requestText.length > this.minLengthForRequest) {
          if (this.timer) {
            clearTimeout(this.timer);
          }

          let _this = this

          this.timer = setTimeout(() => {
            $.request('ArticleList::onGetKeywords', {
              data: {
                query: this.requestText
              },

              success(response) {
                _this.refreshSearchHistory(response)
              },
            });
          }, this.delayForRequest);
        } 
        if ($(e.currentTarget).val().length == 0) {
          $(this.searchInputCleanBtn).hide()
        }
      })
      .on('keydown', this.searchInput, (e) => {
        if (e.key === 'Enter') {
          if (this.page !== 'search') {
            window.location.href = `/${this.searchPageURL}?search=${this.requestText}`
          } else {
            SearchResult.onRequestFilterData()
            this.hideSearchHistory()
          }
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          e.preventDefault()
          this.scrollHistoryItemsByArrows(e.key)
        }
      })
      .on('click', this.searchIcon, (e) => {
        if (this.page !== 'search') {
          window.location.href = `/${this.searchPageURL}?search=${this.requestText}`
        } else {
          SearchResult.onRequestFilterData()
          this.hideSearchHistory()
        }
      })
      .on('click', this.searchInput, () => {
        $(this.searchHistory).show()
      })
      .on('click', this.searchInputCleanBtn, () => {
        $(this.searchInputCleanBtn).hide()
        $(this.searchInput).val('')
        this.requestText = ''
        $(this.searchInput).focus()
      })
      .on('keydown', (event) => {
        if (event.key == 'Escape') {
          this.hideSearchHistory()
        }
      })
      .on('click', (event) => {
        const historyBlock = $(this.searchHistory)
        const searchContainer = $(this.searchBarContainer)
        const mobileSearchIcon = $('.header__search')

        // close Search History block, when click to screen out of History block
        if(searchContainer.find(event.target).length == 0
              && historyBlock.find(event.target).length == 0
              && historyBlock.is(':visible')) {
          this.hideSearchHistory()
        }
        // close Search Bar, when click to screen out of Search Bar in mobile version
        if (mobileSearchIcon.length != 0) {
          if (searchContainer.find(event.target).length == 0
          && historyBlock.find(event.target).length == 0
          && mobileSearchIcon.find(event.target).length == 0
          && searchContainer.is(':visible')) {
            // don't close Search Bar on Search Page
            if(window.location.href.indexOf(this.searchPageURL) == -1 ) {
              searchContainer.hide()
              $(this.headerSearchSvg).show()
            }
          }
        }
      })
  }

  hideSearchHistory () {
    $(this.searchHistory).hide()
    let historyItems = Array.from(document.querySelectorAll(this.searchHistoryItem))
    historyItems.forEach((item) => {
      item.classList.remove('selected')
    })
  }

  scrollHistoryItemsByArrows(key) {
    let historyItems = Array.from(document.querySelectorAll(this.searchHistoryItem))
    let input = document.querySelector(this.searchInput)

    historyItems = historyItems.filter((item) => item.style.display == 'flex')

    if (historyItems.length == 0) {
      return
    }

    let selectedItemIndex = historyItems.findIndex(item => item.classList.contains('selected'))
    if (selectedItemIndex == -1) {
      if (key == 'ArrowDown') {
        historyItems[0].classList.add('selected')
        $(this.searchInput).val(historyItems[0].querySelector('.search__history__item__span')?.innerHTML)
        input.selectionStart = input.value.length;
        $(this.searchInputCleanBtn).show()
      } else {
        historyItems.at(-1).classList.add('selected')
        $(this.searchInput).val(historyItems.at(-1).querySelector('.search__history__item__span')?.innerHTML)
        input.selectionStart = input.value.length;
        $(this.searchInputCleanBtn).show()
      }
    } else {
      historyItems[selectedItemIndex].classList.remove('selected')

      if (key == 'ArrowDown') {
        let newIndex = selectedItemIndex+1 <= historyItems.length - 1 ? selectedItemIndex + 1 : 0
        historyItems[newIndex].classList.add('selected')
        $(this.searchInput).val(historyItems[newIndex].querySelector('.search__history__item__span')?.innerHTML)
        input.selectionStart = input.value.length;
        $(this.searchInputCleanBtn).show()
      } else {
        let newIndex = selectedItemIndex-1 >= 0 ? selectedItemIndex - 1 : historyItems.length - 1
        historyItems[newIndex].classList.add('selected')
        $(this.searchInput).val(historyItems[newIndex].querySelector('.search__history__item__span')?.innerHTML)
        input.selectionStart = input.value.length;
        $(this.searchInputCleanBtn).show()
      }
    }
  }

  refreshSearchHistory (response) {
    let searchHistoryItems = $(this.searchHistoryItem)
    searchHistoryItems.each((index, item) => {
      let itemLabel = item.querySelector('span')
      if (response[index] != undefined) {
        itemLabel.closest(this.searchHistoryItem).style.display = 'flex'
        itemLabel.innerHTML = response[index]
      } else {
        itemLabel.closest(this.searchHistoryItem).style.display = 'none'
      }
    })
  }
}();
